module.exports = __webpack_public_path__ + "img/glogo220.7ae67af6.png";